var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDistance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "14px",
    viewBox: "0 0 12 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "DCP-Manage-Rides",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-HD",
    transform: "translate(-544.000000, -405.000000)",
    fill: "#ff5f00",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons/24x24/ico_pins",
    transform: "translate(542.000000, 404.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0002,5.3334 L3.33353333,5.3334 L3.33353333,12.0000667 L5.87555372,12.0000667 L6.66671942,12.7907382 L7.45739096,12.0000667 L10.0002,12.0000667 L10.0002,5.3334 Z M2.0002,13.3334 L2.0002,4.00006667 L11.3335333,4.00006667 L11.3335333,13.3334 L8.00967571,13.3334 L6.66701391,14.6760618 L5.32351295,13.3334 L2.0002,13.3334 Z M12.6668667,2.66673333 L6.66686667,2.66673333 L6.66686667,1.3334 L14.0002,1.3334 L14.0002,8.66673333 L12.6668667,8.66673333 L12.6668667,2.66673333 Z M5.51133333,9.82266667 L5.51133333,7.51133333 L7.82266667,7.51133333 L7.82266667,9.82266667 L5.51133333,9.82266667 Z",
    id: "shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDistance);
export default __webpack_public_path__ + "static/media/distance.e60affb21350b3e4dcac753e9de3d928.svg";
export { ForwardRef as ReactComponent };